import { createSlice } from "@reduxjs/toolkit";

const setRulesSlice = createSlice({
  name: "setRulesDataSetUp",
  initialState: {
    timeSupervisionData: null,
    setRulesData: null,
    UsedAppTimeDataModel: null,
    AdminSetRuleLanguageData: [],
    AdminSetRuleData: null,
    activeTab: "SETRULE_SCREENSHOTS",
    setupWizardDeviceId: null
  },
  reducers: {
    setRuleDataSetUp: (state, action) => {
      state.setRulesData = action?.payload
    },
    setRuleTimeSupervisionData: (state, action) => {
      state.timeSupervisionData = action?.payload
    },
    setRuleUsedAppTimeDataModel: (state, action) => {
      state.UsedAppTimeDataModel = action?.payload
    },
    setAdminSetRuleLanguageData: (state, action) => {
      state.AdminSetRuleLanguageData = action?.payload
    },
    setAdminSetRuleData: (state, action) => {
      state.AdminSetRuleData = action?.payload
    },
    setActiveTab: (state, action) => {
      state.activeTab = action?.payload
    },
    setSetupWizardDeviceId: (state, action) => {
      state.setupWizardDeviceId = action?.payload
    },
    clearSetRules: (state, action) => {
      state.timeSupervisionData = null
      state.setRulesData = null
      state.UsedAppTimeDataModel = null
      state.AdminSetRuleLanguageData = []
      state.AdminSetRuleData = null
      state.activeTab = "SETRULE_SCREENSHOTS"
      state.setupWizardDeviceId = null
    }
  }
});


// this is for dispatch
export const {
  setRuleDataSetUp,
  setRuleTimeSupervisionData,
  setRuleUsedAppTimeDataModel,
  setAdminSetRuleData,
  setAdminSetRuleLanguageData,
  setActiveTab,
  clearSetRules,
  setSetupWizardDeviceId
} = setRulesSlice.actions;

// this is for configureStore
export default setRulesSlice.reducer;